export default class SmsEditor {
  constructor(smsObj = {}) {
    'ngInject';

    this.smsObj = smsObj;
  }

  onSelectRecipient(recipient, numberKey = 'phoneNumber') {
    const isSmsObjects = typeof recipient === 'object';

    if (!(isSmsObjects ? recipient[numberKey] : recipient)) {
      this.isRecipientsInValid = true;
      return;
    }

    if (this.smsObj.recipientsPhoneNumbers) {
      this.smsObj.recipientsPhoneNumbers = [
        ...this.smsObj.recipientsPhoneNumbers,
        recipient,
      ];
    } else {
      this.smsObj.recipientsPhoneNumbers = [recipient];
    }
  }

  onRemoveRecipient(recipient) {
    if (!this.smsObj || !this.smsObj.recipientsPhoneNumbers) {
      return;
    }

    const indexOfRecipient = this.smsObj.recipientsPhoneNumbers.indexOf(
      recipient,
    );
    this.smsObj.recipientsPhoneNumbers = [
      ...this.smsObj.recipientsPhoneNumbers.slice(0, indexOfRecipient),
      ...this.smsObj.recipientsPhoneNumbers.slice(indexOfRecipient + 1),
    ];
  }

  onUpdateSubject(subject) {
    this.smsObj.subject = subject;
  }

  onUpdateBody(body) {
    this.smsObj.body = body;
  }
}
